<template>
<WidgetVue
title="SentiSolv AI-Question Answering LLM"
desc="Chat with your company's review"
>
  <div class="qa">
   
    <div v-if="qaset">
      <label class="label" for="">Type your question here</label><br />
      <select class="select-box" v-model="selected_question">
        <option v-for="qa in qaset" :key="qa.id">
          {{ qa.question }}
        </option>
      </select>
      <div id="result" v-if="answer">
        <h2>Refined Customer Reviews:</h2>
        <div>
          <div v-for="item in answer" :key="item" class="refined_item">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <div v-else>Data cannot loaded.</div>
  </div>
</WidgetVue> 
</template>
<script>
import WidgetVue from "@/components/WidgetVue.vue"
export default {
  name: "QA",
  data() {
    return {
      qaset: null,
      // company_data_name: "groupa-blackstone",
      selected_question: null,
      answer: null,
    };
  },
  //Create Vue prop as 'company_data_name' and set default value as 'groupa-blackstone'
  props: {
    company_data_name: {
      type: String
    },
  },
  components:{
    WidgetVue
  },
 

  methods: {
    getQA() {
      this.qaset = require(`@/assets/qa/${this.company_data_name}.json`);
      // console.log(this.qaset);
    },
    update_answer() {
      this.answer = this.qaset.find(
        (x) => x.question === this.selected_question
      )?.results;
    },
  },
  created() {
    this.getQA();
  },
  watch: {
    selected_question: "update_answer", // Watch for changes in selected_question and call update_answer
  },
};
</script>
<style scoped>
#result {
  padding-top: 100px;
  text-align: justify;
}

.refined_item {
  padding: 20px;
  margin-top: 20px;
  border: solid 1px gray;
}

.title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.label {
  font-size: 18px;
}

.select-box {
  display: block;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.select-box:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>